export const LOCALES_TO_LANGS = {
  en: 'English',
  fr: 'Français',
  nl: 'Nederlands',
};

export const MEDIA_TYPES = {
  VIDEO: 'Video',
  PODCAST: 'Podcast',
};
